import MainLayoutView from './views/MainLayoutView/MainLayoutView';
import { useAnalyticsTracking } from './hooks/useAnalyticsTracking';

function App() {
  useAnalyticsTracking();
  return <MainLayoutView />;
}

export default App;
